module.exports = __webpack_public_path__ + "img/art_4_3.a7da120f.png";